import checkMatch from './checkMatch';
import isNode from './isNode';

export default function(element, selector, topElement, includeTopElement = true) {
    let parents = [];

    // If the element is not set or not a node return empty array
    if (!isNode(element)) {
        return parents;
    }

    // If the top element is not set or not a node set it to document
    if (!isNode(topElement)) {
        topElement = document;
    }
    let parentElement = element.parentNode;
    while (parentElement && parentElement !== topElement) {
        if (checkMatch(parentElement, selector)) {
            parents.push(parentElement);
        }
        parentElement = parentElement.parentNode;
    }
    if (includeTopElement && checkMatch(parentElement, selector)) {
        parents.push(parentElement);
    }

    return parents;
}
